import { TranslateService } from '@ngx-translate/core';
import { Notification, NotificationData } from './notification.model';

export class GlobalNotificationModel extends Notification {
  constructor(
    data: NotificationData,
    private readonly translateService: TranslateService,
  ) {
    super(data);
    this.actionName = this.translateService.instant('view');
    this.description = this.translateService.instant(data?.globalNotification?.text_body || 'none');
    this.actionRequired = !this.readDate;
  }
}
